import React from 'react'
import { useTranslation } from 'react-i18next'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Switch from '@material-ui/core/Switch'
import FormControl from '@material-ui/core/FormControl'

import useStyles from './active-toggle.styles'

const ActiveToggle = ({ ...props }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  return (
    <FormControl margin="normal" variant="outlined" fullWidth>
      <Grid container alignItems="center">
        <Grid item>
          <Typography variant="button" className={classes.switchText}>
            {t('active')}
          </Typography>
        </Grid>
        <Grid item>
          <Switch checked={props.value} onChange={props.onToggle} name="statusCheckbox" />
        </Grid>
        <Grid item>
          <Typography variant="button" className={classes.switchText}>
            {t('inactive')}
          </Typography>
        </Grid>
      </Grid>
    </FormControl>
  )
}

export default ActiveToggle
